
import Methods from '../methods'

const loadAllLocationNodes= (context) =>{
  const url = `api/nodes`
  return Methods.doGet(context,url,null)
}


const saveLocationNode= (context, params) =>{
  const url = `api/node`
  return Methods.doPost(context,url,params.locationNode,null)
}


const deleteLocationNode= (context, params) =>{
  const url = `api/node/${params.id}`
  return Methods.doDelete(context,url,null)
}

export default {
  loadAllLocationNodes,
  saveLocationNode,
  deleteLocationNode
}



// WEBPACK FOOTER //
// ./src/api/modules/LocationNodeApi.js